import store from 'shared/store';
import { createApp } from 'vue';
import CheckoutConfirmation from '../SharedComponents/checkoutConfirmation.vue';

import "../Styles/_c-global-checkout.scss";

const mountPoint = document.querySelector('[data-feature="globalCheckoutErrorStepPage"]');
if (mountPoint) {
	const app = createApp({
		name: 'GlobalCheckoutErrorStepPage',
	});
	app.use(store);

	app.component('checkout-confirmation', CheckoutConfirmation);
	app.mount(mountPoint);
}
